/* eslint-disable @typescript-eslint/no-explicit-any */
export const connectionOptions = [
    {
        value: 'Rotatably connected to',
        label: 'Rotatably connected to',
    },
    {
        value: 'Slidably engaged with',
        label: 'Slidably engaged with',
    },
    {
        value: 'Electromagnetically engaged with',
        label: 'Electromagnetically engaged with',
    },
    {
        value: 'Coupled to',
        label: 'Coupled to',
    },
    {
        value: 'Movably coupled to',
        label: 'Movably coupled to',
    },
    {
        value: 'Integral with',
        label: 'Integral with',
    },
    {
        value: 'Coextruded with',
        label: 'Coextruded with',
    },
]

export const connectionRelation: any = {
    'Coupled to': [
        {
            label: 'Coupled to',
            value: 'Coupled to',
        },
        {
            label: 'Fixed to',
            value: 'Fixed to',
        },
        {
            label: 'Attached to',
            value: 'Attached to',
        },
        {
            label: 'Adhered to',
            value: 'Adhered to',
        },
    ],
    'Movably coupled to': [
        {
            label: 'Movably coupled to',
            value: 'Movably coupled to',
        },
        {
            label: 'Rotatably coupled to',
            value: 'Rotatably coupled to',
        },
        {
            label: 'Slidably coupled to',
            value: 'Slidably coupled to',
        },
        {
            label: 'Reversibly coupled to',
            value: 'Reversibly coupled to',
        },
    ],
    'Electromagnetically engaged with': [
        {
            label: 'Electromagnetically engaged with',
            value: 'Electromagnetically engaged with',
        },
        {
            label: 'Electrically attracted',
            value: 'Electrically attracted',
        },
        {
            label: 'Electrically repelled',
            value: 'Electrically repelled',
        },
        {
            label: 'Magnetically attracted',
            value: 'Magnetically attracted',
        },
        {
            label: 'Magnetically repelled',
            value: 'Magnetically repelled',
        },
    ],
}
